import { debounce } from "es-toolkit/function";
import { useEffect, useMemo, useState } from "react";

export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    const debouncedSet = useMemo(
        () => debounce((next: T) => setDebouncedValue(next), delayMs),
        [delayMs],
    );

    useEffect(() => {
        debouncedSet(value);
        return () => debouncedSet.cancel();
    }, [value, debouncedSet]);

    return debouncedValue;
};
